import React, { useEffect, useState } from "react";
import { Pilihan } from "./pilihan";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import useVerify from "./useVerify";

function QuizPage() {
  useVerify("user");

  const location = useLocation();
  const { baseQuestion, quizId } = location.state;
  const [missingOptions, setMissingOptions] = useState([]);

  const [rightAnswer, setRightAnswer] = useState(0);

  const [time, setTime] = useState(60);
  const [intervalId, setIntervalId] = useState(null);

  const [sesi, setSesi] = useState(0);

  const [totalCorrect, setTotalCorrect] = useState(0);
  const [listCorrect, setListCorrect] = useState([]);

  const navigate = useNavigate();

  const [account, setAccount] = useState({});

  const [saveQuestions, setSaveQuestions] = useState([[]]);
  const [answerUser, setAnswerUser] = useState([[]]);
  const [correctUser, setCorrectUser] = useState([[]]);

  const [totalCorrectHasil, setTotalCorrectHasil] = useState(0);

  useEffect(() => {
    // get account data
    setAccount(JSON.parse(Cookies.get("account")));
  }, []);

  useEffect(() => {
    // generate first question
    generateQuestion();

    const id = setInterval(() => {
      setTime((time) => time - 1);
    }, 1000);
    setIntervalId(id);

    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [sesi, baseQuestion]);

  // menghentikan waktu mundur jika sudah 00:00
  useEffect(() => {
    if (time === 0) {
      // insert totalCorrect to listTotalCorrect
      const newList = listCorrect.concat(totalCorrect);
      setListCorrect(newList);

      if (sesi < baseQuestion.length - 1) {
        setTotalCorrect(0);
        setTime(60);
        setSesi((sesi) => sesi + 1);
      } else {
        console.log(correctUser);
        clearInterval(intervalId);

        // Bug fix: navigate dipindah ke dalam .then() agar data sempat tersimpan
        fetch(`${process.env.REACT_APP_BASE_URL}/api/add_hasil`, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            userId: account.userId,
            quizId: quizId,
            totalCorrectHasil: totalCorrectHasil,
          }).toString(),
        })
          .then((response) => response.json())
          .then((data) => {
            addDataAnswerKolomsAndJawabans(data.hasilId, newList);
            navigate("/result", {
              state: { listCorrect: newList },
            });
          });
      }
    }
    // eslint-disable-next-line
  }, [time]);

  function generateQuestion() {
    // ambil 1 index acak
    const randomTmp = Math.floor(Math.random() * 5);
    setRightAnswer(randomTmp);

    // acak missing questions
    let missingTmp = [...baseQuestion[sesi].kolom];
    missingTmp.splice(randomTmp, 1);
    missingTmp = _.shuffle(missingTmp);
    setMissingOptions(missingTmp);
  }

  const handleChange = (value) => {
    const userAnswer = value;

    if (userAnswer === rightAnswer) {
      setTotalCorrect((totalCorrect) => totalCorrect + 1);
      setTotalCorrectHasil((totalCorrectHasil) => totalCorrectHasil + 1);
      setCorrectUser(handleSaveState(correctUser, 1));
    } else {
      setCorrectUser(handleSaveState(correctUser, 0));
    }
    setAnswerUser(
      handleSaveState(answerUser, baseQuestion[sesi].kolom[userAnswer])
    );

    setSaveQuestions(handleSaveState(saveQuestions, missingOptions));

    generateQuestion();
  };

  function handleSaveState(array, newItem) {
    const newSaveState = [...array];
    if (!newSaveState[sesi]) newSaveState[sesi] = [];
    newSaveState[sesi].push(newItem);
    return newSaveState;
  }

  function addDataAnswerKolomsAndJawabans(hasilId, kolomAnswer) {
    // console.log(kolomAnswer);
    kolomAnswer.forEach((input, index) => {
      fetch(`${process.env.REACT_APP_BASE_URL}/api/add_kolom-answer`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          hasilId: hasilId,
          kolomId: baseQuestion[index].kolomId,
          totalCorrectKolom: input,
        }).toString(),
      })
        .then((response) => response.json())
        .then((data) => {
          addDataJawabans(data.kolomAnswerId, index);
        });
    });
  }

  function addDataJawabans(kolomAnswerId, index) {
    if (!saveQuestions[index]) saveQuestions[index] = [];

    saveQuestions[index].forEach((input, idx) => {
      fetch(`${process.env.REACT_APP_BASE_URL}/api/add_jawaban`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          kolomAnswerId: kolomAnswerId,
          question: input,
          answer: answerUser[index][idx],
          correct: correctUser[index][idx],
        }).toString(),
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
        });
    });
  }

  return (
    <div className="container mx-auto p-4 max-w-lg">
      <img
        className="mt-8 mb-12 mx-auto h-20 w-auto"
        src="./assets/img/logo-oc-1.png"
        alt="OWL Course"
      />
      <h1 className="text-4xl font-bold ml-4 mb-3 text-[#FF914D]">
        Quiz Kecermatan
      </h1>
      <p className="ml-4">Total benar : {totalCorrect}</p>
      <form className="p-4">
        <label className="block font-bold mb-2">
          {time > 0
            ? `${Math.floor(time / 60)}:${
                time % 60 < 10 ? `0${time % 60}` : time % 60
              }`
            : "Waktu habis"}
        </label>

        <table className="w-full border-[#3F3B3C] border-[1px] rounded-lg mb-4">
          <tbody>
            <tr>
              {baseQuestion[sesi].kolom.map((option) => (
                <td
                  key={option}
                  className="border-[#3F3B3C] border-[1px] p-2 text-center text-3xl font-bold"
                >
                  {option}
                </td>
              ))}
            </tr>
            <tr>
              <td className="border-[#3F3B3C] border-[1px] p-2 text-center">
                A
              </td>
              <td className="border-[#3F3B3C] border-[1px] p-2 text-center">
                B
              </td>
              <td className="border-[#3F3B3C] border-[1px] p-2 text-center">
                C
              </td>
              <td className="border-[#3F3B3C] border-[1px] p-2 text-center">
                D
              </td>
              <td className="border-[#3F3B3C] border-[1px] p-2 text-center">
                E
              </td>
            </tr>
          </tbody>
        </table>

        <div className="w-full p-4 flex gap-2 justify-center rounded-lg border-blue-500 border-2 mb-4">
          {missingOptions.map((option) => (
            <div key={option} className="font-bold text-blue-500">
              {option}
            </div>
          ))}
        </div>

        <div className="flex gap-2 justify-center">
          <Pilihan value={0} handleChange={handleChange} />
          <Pilihan value={1} handleChange={handleChange} />
          <Pilihan value={2} handleChange={handleChange} />
          <Pilihan value={3} handleChange={handleChange} />
          <Pilihan value={4} handleChange={handleChange} />
        </div>
      </form>
    </div>
  );
}

export default QuizPage;
